import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { rapportsApi } from '../api/rapports.api';

export function RapportAuditPage() {
  const [page, setPage] = useState(1);
  const [typeOperation, setTypeOperation] = useState('');

  const { data, isLoading } = useQuery({
    queryKey: ['audit', { page, typeOperation }],
    queryFn: () => rapportsApi.audit({ page, pageSize: 50, typeOperation: typeOperation || undefined }),
  });

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-content mb-6">Rapport d'audit</h1>

      <div className="flex gap-3 mb-4">
        <input
          type="text"
          placeholder="Filtrer par type d'opération..."
          value={typeOperation}
          onChange={e => { setTypeOperation(e.target.value); setPage(1); }}
          className="border border-border rounded px-3 py-2 text-sm w-64 focus:outline-none focus:ring-2 focus:ring-primary"
        />
        <span className="text-sm text-content-subtle self-center">{data?.total ?? '—'} opération(s)</span>
      </div>

      {isLoading && <p className="text-content-subtle text-sm">Chargement...</p>}

      {data && (
        <>
          <div className="overflow-x-auto rounded-lg border border-border">
            <table className="min-w-full divide-y divide-border text-sm">
              <thead className="bg-surface-raised">
                <tr>
                  {['Date', 'Action', 'Module', 'Entité', 'ID Entité'].map(h => (
                    <th key={h} className="px-3 py-3 text-left text-xs font-medium text-content-subtle uppercase">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-surface divide-y divide-border">
                {data.lignes.map((l: any) => (
                  <tr key={l.idLog} className="hover:bg-surface-raised">
                    <td className="px-3 py-2 text-content-subtle">{new Date(l.dateOperation).toLocaleString('fr-FR')}</td>
                    <td className="px-3 py-2 font-medium text-content">{l.action}</td>
                    <td className="px-3 py-2 text-content-muted">{l.module}</td>
                    <td className="px-3 py-2 text-content-muted">{l.entityType ?? '—'}</td>
                    <td className="px-3 py-2 text-content-subtle font-mono text-xs">{l.entityId ?? '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-between items-center mt-4">
            <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} className="text-sm text-accent disabled:text-content-subtle">← Précédent</button>
            <span className="text-sm text-content-muted">Page {page}</span>
            <button onClick={() => setPage(p => p + 1)} disabled={data.lignes.length < 50} className="text-sm text-accent disabled:text-content-subtle">Suivant →</button>
          </div>
        </>
      )}
    </div>
  );
}
